import React from 'react';
import { I18n } from '@aws-amplify/core';
import * as S from './styles';

interface QuestionStructure {
	sequence: number;
	question: string;
	response: 'yes' | 'no' | null;
}

interface TableCategoryQuestionsReviewProps {
	exposure_time: number;
	first_step: QuestionStructure[];
	second_step: QuestionStructure[];
}

export function TableCategoryQuestionsReview({
	exposure_time,
	first_step,
	second_step
}: Readonly<TableCategoryQuestionsReviewProps>): JSX.Element {
	return (
		<S.TableWrapper>
			<S.CustomTable>
				<thead>
					<tr>
						<th colSpan={3}>{I18n.get('Exposure time')}</th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td colSpan={2}>
							{I18n.get('Indicate the time of exposure to the risk factor (in percentage)')}
						</td>
						<td style={{ width: '10%', textAlign: 'center' }}>{exposure_time}%</td>
					</tr>
				</tbody>
				<thead>
					<tr>
						<th colSpan={3}>{I18n.get('Step')} 1</th>
					</tr>
				</thead>
				<tbody>
					{first_step.map((question) => (
						<tr key={question.sequence}>
							<td style={{ width: '5%' }}>{question.sequence}</td>
							<td>{I18n.get(question.question)}</td>
							<td style={{ width: '10%', textAlign: 'center' }}>
								{question.response === 'yes' ? I18n.get('Yes') : I18n.get('No')}
							</td>
						</tr>
					))}
				</tbody>
				<thead>
					<tr>
						<th colSpan={3}>{I18n.get('Step')} 2</th>
					</tr>
				</thead>
				<tbody>
					{second_step.map((question) => (
						<tr key={question.sequence}>
							<td style={{ width: '5%' }}>{question.sequence}</td>
							<td>{I18n.get(question.question)}</td>
							<td style={{ width: '10%', textAlign: 'center' }}>
								{question.response === 'yes' ? I18n.get('Yes') : I18n.get('No')}
							</td>
						</tr>
					))}
				</tbody>
			</S.CustomTable>
		</S.TableWrapper>
	);
}
